import { render } from "./TextAlert.vue?vue&type=template&id=46e9e5ac&scoped=true&ts=true"
import script from "./TextAlert.vue?vue&type=script&lang=ts"
export * from "./TextAlert.vue?vue&type=script&lang=ts"

import "./TextAlert.vue?vue&type=style&index=0&id=46e9e5ac&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e9e5ac"]])

export default __exports__